// extracted by mini-css-extract-plugin
export var container = "_h0-0";
export var icon = "_h0-1";
export var text = "_h0-2";